import { MyTasksFiltersState, MyTasksFiltersActionTypes, READ_MY_TASKS_FILTERS_REQUEST, READ_MY_TASKS_FILTERS_SUCCESS, READ_MY_TASKS_FILTERS_FAILURE } from "store/reducers/types/myTasks/myTasksFilters";

const defaultState: MyTasksFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function myTasksFilters(state = defaultState, action: MyTasksFiltersActionTypes): MyTasksFiltersState {
  switch (action.type) {
    case READ_MY_TASKS_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_MY_TASKS_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_MY_TASKS_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};